import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Norwegian } from "flatpickr/dist/l10n/no.js";
import { english } from "flatpickr/dist/l10n/default.js";

import WP from "WP";
import { currentLanguage } from "helpers";
import useIsMobile from "hooks/useIsMobile";

import IconSelector from "partials/IconSelector";

import Media from "css/Media";

const DateRangePicker = ({
  fromDate,
  toDate,
  dateHandler,
  className,
  valid,
  isDark,
}) => {
  const datePickr = useRef(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    initFlatPickr();
  }, [isMobile]);

  const initFlatPickr = () => {
    flatpickr.l10ns.no.rangeSeparator = "  ─  ";
    flatpickr.l10ns.no.months.shorthand =
      flatpickr.l10ns.no.months.shorthand.map((month) => month.toLowerCase());

    flatpickr.l10ns.default.rangeSeparator = "  ─  ";
    flatpickr.l10ns.default.months.shorthand =
      flatpickr.l10ns.default.months.shorthand.map((month) =>
        month.toLowerCase()
      );
    flatpickr.l10ns.default.firstDayOfWeek = 1;

    let locale = WP.lang === "no" ? Norwegian : english;

    let options = {
      locale: locale,
      mode: "range",
      minDate: "today",
      altInput: true,
      altFormat: "D. j. M",
      dateFormat: "Y-m-d\\TH:S",
      onChange: dateHandler,
      showMonths: isMobile ? 1 : 2,
    };

    // If we're provided a daterange (fromDate, toDate) we'll populate the flatpickr
    if (fromDate && toDate) {
      fromDate = new Date(fromDate);
      toDate = new Date(toDate);

      options.defaultDate = [fromDate, toDate];
    }

    flatpickr(datePickr.current, options);
  };

  return (
    <StyledLabel valid={valid} className={className} isDark={isDark}>
      <IconSelector negative={isDark} icon='calender' />
      <StyledInput
        ref={datePickr}
        placeholder={
          valid
            ? currentLanguage() === "no"
              ? "Fra   ─   Til"
              : "From   ─   To"
            : WP.trans.chooseDates
        }
        valid={valid ? 1 : 0}
      />
    </StyledLabel>
  );
};

export default DateRangePicker;

const StyledLabel = styled.label`
  width: 100%;
  display: flex;
  margin-bottom: ${(props) => props.theme.spacing.contentXS};

  ${Media.greaterThan("s")`
        margin-bottom: 0;
    `}

  input::placeholder {
    color: ${(props) =>
      props.valid
        ? props.isDark
          ? props.theme.colors.negative
          : props.theme.colors.text
        : props.theme.colors.button};
  }
`;

const StyledInput = styled.input`
  width: 100%;
  cursor: pointer;
  border: none;
  border-bottom: 1px solid
    ${(props) =>
      props.valid ? props.theme.colors.lines : props.theme.colors.button};
  padding: ${(props) => props.theme.spacing.contentXS};
  font-size: 16px;
  font-family: "Untitled";
  color: ${(props) => props.theme.colors.text};
`;
